import type {EditorView} from '@codemirror/view'
import type {Element} from 'hast'

import {registerInvalidVideoUrl} from '../extensions/invalid-video-urls'
import {HastElementWidget} from './hast-element'

/** Renders a video node and registers invalid video URLs on error. */
export class VideoWidget extends HastElementWidget {
  constructor(node: Element, className: string) {
    if (node.tagName !== 'video') throw new Error('VideoWidget can only be used with video elements')
    super(node, className)
  }

  override toDOM(view: EditorView) {
    const videoElement = super.toDOM(view) as HTMLVideoElement
    videoElement.addEventListener('error', () => {
      registerInvalidVideoUrl(view, videoElement.src)
    })
    return videoElement
  }
}
